import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import config from '../../config';


const BetaFirmware = (props) => {
  const history = useHistory();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('betaModal') === 'true') {
      const modal = new window.bootstrap.Modal(document.getElementById('exampleModal'));
      const modal2 = new window.bootstrap.Modal(document.getElementById('exampleModal2'));
      modal.show();
      modal2.show();

      // Remove query parameter after 15 seconds
      const timeoutId = setTimeout(() => {
        // console.log('kuchbhi');
        history.push(window.location.pathname);
      }, 1000);

      // Cleanup timeout on component unmount
      return () => clearTimeout(timeoutId);
    }

    // Initialize the modal
    const modalElement2 = document.getElementById('exampleModal2');
    const modal2 = new window.bootstrap.Modal(modalElement2);
    const modalElement = document.getElementById('exampleModal');
    const modal = new window.bootstrap.Modal(modalElement);

    const learnMoreButton2 = document.getElementById('learnMoreButton2');
    learnMoreButton2.addEventListener('click', () => {
      modal2.show();
    });
    const learnMoreButton = document.getElementById('learnMoreButton');
    learnMoreButton.addEventListener('click', () => {
      modal.show();
    });

    // Cleanup event listeners on unmount
    return () => {
      learnMoreButton2.removeEventListener('click', () => {
        modal2.show();
      });
      learnMoreButton.removeEventListener('click', () => {
        modal.show();
      });
    };
  }, [history]);

  return (
    <>
      <h2>
        <strong>SmallHD PageOS 6</strong> <span>Firmware v6.3.2-Beta-0</span>
      </h2>
      <div className="card mb-lg-5">
        <div className="card-body">
          <div className="row mb-3">
            <div className="col-md-5">
              <h3 className="text-dark">
                <small className="d-block mb-3 text-black-50">Version</small>{" "}
                <span>
                  6.3.2<small>-Beta-0</small>
                </span>
              </h3>
            </div>
            <div className="col-md-7">
              <h3 className="text-dark">
                <small className="d-block mb-3 text-black-50">Updated on</small>{" "}
                13 Mar, 2026
              </h3>
            </div>
          </div>
          <h2>
            Important Beta Software Information: <strong>PLEASE READ BELOW</strong>
          </h2>
          <ul className="list-txt">
            <li><strong>OLDER FIRMWARE IS LISTED BELOW, CLICK “SHOW MORE”</strong></li>
            <li>
              <a className="text-decoration-underline" href="https://support.cs.inc/s/article/SmallHD-Monitors-Currently-Supported-In-The-Latest-PageOS-Firmware">Click Here</a> for a complete list of compatible monitors
            </li>
            <li>
              This firmware will NOT support the following monitors:
              <ul>
                <li>Focus 5 & 7 (LCD, OLED, HDMI, SDI, & RX/TX)</li>
                <li>2403 HDR & 2403 HB</li>
              </ul>
            </li>
          </ul>
          <div className="btn-col">
            <button
              type="button"
              className="btn btn-outline-dark"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal2"
              id="learnMoreButton2"
            >
              Learn More
            </button>

            <a
              href="#"
              onClick={() =>
                props.showpopupdownload(
                  `${config.downloadFirmwareUrl}beta/SmallHD_PageOS_V6-3-2-beta-0.zip`
                )
              }
              className="btn btn-primary text-white"
            >
              Download
            </a>
          </div>
        </div>
      </div>

      <h2>
        <strong>SmallHD PageOS 6</strong> <span>Firmware v6.3.0-Beta0</span>
      </h2>
      <div className="card mb-lg-5">
        <div className="card-body">
          <div className="row mb-3">
            <div className="col-md-5">
              <h3 className="text-dark">
                <small className="d-block mb-3 text-black-50">Version</small>{" "}
                <span>
                  6.3.0<small>-Beta0</small>
                </span>
              </h3>
            </div>
            <div className="col-md-7">
              <h3 className="text-dark">
                <small className="d-block mb-3 text-black-50">Updated on</small>{" "}
                04 Nov, 2025
              </h3>
            </div>
          </div>
          <h2>
            Important Beta Software Information: <strong>PLEASE READ BELOW</strong>
          </h2>
          <ul className="list-txt">
            <li><strong>OLDER FIRMWARE IS LISTED BELOW, CLICK “SHOW MORE”</strong></li>
            <li>
              <a className="text-decoration-underline" href="https://support.cs.inc/s/article/SmallHD-Monitors-Currently-Supported-In-The-Latest-PageOS-Firmware">Click Here</a> for a complete list of compatible monitors
            </li>
            <li>
              This firmware will NOT support the following monitors:
              <ul>
                <li>Focus 5 & 7 (LCD, OLED, HDMI, SDI, & RX/TX)</li>
                <li>2403 HDR & 2403 HB</li>
              </ul>
            </li>
          </ul>
          <div className="btn-col">
            <button
              type="button"
              className="btn btn-outline-dark"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
              id="learnMoreButton"
            >
              Learn More
            </button>

            <a
              href="#"
              onClick={() =>
                props.showpopupdownload(
                  `${config.downloadFirmwareUrl}beta/SmallHD_PageOS_V6-3-0-beta-0.zip`
                )
              }
              className="btn btn-primary text-white"
            >
              Download
            </a>
          </div>
        </div>
      </div>

      <div
        className="modal fade beta-firmware-modal"
        id="exampleModal2"
        tabIndex="-1"
        aria-labelledby="exampleModal2Label"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h2 className="modal-title" id="exampleModal2Label">
                <strong>SmallHD PageOS 6</strong>{" "}
                <span>Firmware v6.3.2-Beta-0</span>
              </h2>
              {/* <button
                type="button"
                className="btn-close"
                data-bs="modal"
                aria-label="Close"
              >
              </button> */}
            </div>

            <div className="modal-body">
              <div className="mb-4">
                <h2 className="bg-warning d-inline-block">
                  Important Beta Software Information:<strong>: PLEASE READ BELOW</strong>
                </h2>
                <ul className="list-txt">
                  <li><strong>OLDER FIRMWARE IS LISTED BELOW, CLICK “SHOW MORE”</strong></li>
                  <li> <a className="text-decoration-underline" href="https://support.cs.inc/s/article/SmallHD-Monitors-Currently-Supported-In-The-Latest-PageOS-Firmware">Click Here</a> for a complete list of compatible monitors</li>
                  <li>This firmware will NOT support the following monitors:
                    <ul> 
                      <li>Focus 5 & 7 (LCD, OLED, HDMI, SDI, & RX/TX)</li>
                      <li>2403 HDR & 2403 HB</li>
                      <li>1703 HDR & 1703 Studio</li>
                      <li>1303 Studio</li>
                      <li>700 Series - 701, 701L, 702 Bright, 702 OLED</li>
                      <li>500 Series - 501, 502, 502 Bright</li>
                    </ul>
                  </li>
                  <li>This firmware is NOT compatible with the DSMC3 RED®Touch, or Action 5</li>
                  <li>RED® Touch users have firmware available on the <a href="https://downloads.smallhd.com/firmware/red-touch" className="text-decoration-underline">RED® Touch tab</a></li>
                  <li>This firmware is NOT compatible with legacy monitors (DP1, DP6, DP4, AC7, and
                    DP7-PRO)</li>
                  <li><strong>If your firmware is below 3.6.5, we recommend the following upgrade path:
                      3.6.5 {'->'} 4.8.7 {'->'} 5.5.6 {'->'} 6.0.0
                   </strong></li>
                </ul>
              </div>
              <div className="mb-4">
                <h2>
                  <strong>Features Added:</strong>
                </h2>
                <ul className="mb-0">
                  <li>
                    Adds support for Fleet Control App v1.1.0 Beta
                  </li>
                </ul>
              </div>
              <div className="mb-4">
                <h2 className="d-inline-block">
                  <strong>Bugs Fixed:</strong>
                </h2>
                <ul className="list-txt">
                  <li>Smart7 monitor luminance has been corrected to the proper maximum level.</li>
                  <li>Resolved compatibility issues with Nikon ZR and other Nikon cameras using 4K formats. This update may also improve compatibility with additional video sources</li>
                  <li>Fixed HDMI downstream audio when an output LUT is active. Previously, enabling a LUT on the Output Page could disable audio passthrough to downstream devices</li>
                  <li>Improved overall signal stability and touchscreen responsiveness</li>
                  <li>The Appearance menu on Ultra 7 and Ultra 10 monitors can now be accessed via touchscreen</li>
                  <li>Fixed display dimming behavior when creating a new Page. The monitor will no longer enter low-power mode after one minute of inactivity immediately following Page creation</li>
                  <li>Corrected Waveform Spot Meter behavior on 4K Production Monitors. The tool now properly highlights the selected image area</li>
                  <li>Fixed Crosshair Tool interaction. Opening or positioning crosshairs no longer triggers on-screen Function Buttons</li>
                  <li>Corrected menu orientation issues on 4K Production Monitors in portrait mode. Menus now display properly when control buttons are positioned on the right edge</li>
                  <li>Fixed profile loading for Multiview layouts. Saved profiles now correctly restore Multiview Page configurations</li>
                </ul>
              </div>
              <div className="mb-4">
                <h2><strong>Known Issues:</strong></h2>
                <ul className="list-txt">
                  <li><strong>Beta 0</strong> HD Production Monitors: Multiview has a green cast to the image
                    <ul>
                      <li>This will be resolved prior to full firmware release.</li>
                    </ul>
                  </li>
                  <li><strong>Beta 0</strong> Custom Backdrops & No Signal Icons are rotated incorrectly</li>
                  <li>Quantum 32 Waveform has sparkly artifacts in the Waveform data
                    <ul>
                      <li>This has only been observed on a small percentage of units</li>
                    </ul>
                  </li>
                </ul>
              </div>
              <div className="mb-4">
                <h2 className="d-inline-block">
                  <strong>Recommended Practices</strong>
                </h2>
                <ul className="list-txt">
                  <li><strong><i>Connect external recorders directly downstream of your source device (i.e. camera),
not downstream of the monitor</i></strong></li>
                </ul>
              </div>
            </div>
            <div className="modal-footer">
              <a
                target="_blank"
                onClick={() =>
                  props.showpopupdownload(
                    `${config.downloadFirmwareUrl}beta/SmallHD_PageOS_V6-3-2-beta-0.zip`
                  )
                }
                className="btn btn-primary text-white" data-dismiss="modal" aria-label="Close"
              >
                Download
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade beta-firmware-modal"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h2 className="modal-title" id="exampleModalLabel">
                <strong>SmallHD PageOS 6</strong>{" "}
                <span>Firmware v6.3.0-Beta0</span>
              </h2>
              {/* <button
                type="button"
                className="btn-close"
                data-bs="modal"
                aria-label="Close"
              >
              </button> */}
            </div>

            <div className="modal-body">
              <div className="mb-4">
                <h2 className="bg-warning d-inline-block">
                  Important Beta Software Information:<strong>: PLEASE READ BELOW</strong>
                </h2>
                <ul className="list-txt">
                  <li><strong>OLDER FIRMWARE IS LISTED BELOW, CLICK “SHOW MORE”</strong></li>
                  <li> <a className="text-decoration-underline" href="https://support.cs.inc/s/article/SmallHD-Monitors-Currently-Supported-In-The-Latest-PageOS-Firmware">Click Here</a> for a complete list of compatible monitors</li>
                  <li>This firmware will NOT support the following monitors:
                    <ul>
                      <li>Focus 5 & 7 (LCD, OLED, HDMI, SDI, & RX/TX)</li>
                      <li>2403 HDR & 2403 HB</li>
                      <li>1703 HDR & 1703 Studio</li>
                      <li>1303 Studio</li>
                      <li>700 Series - 701, 701L, 702 Bright, 702 OLED</li>
                      <li>500 Series - 501, 502, 502 Bright</li>
                    </ul>
                  </li>
                  <li>This firmware is NOT compatible with the DSMC3 RED®Touch, or Action 5</li>
                  <li>RED® Touch users have firmware available on the <a href="https://downloads.smallhd.com/firmware/red-touch" className="text-decoration-underline">RED® Touch tab</a></li>
                  <li>This firmware is NOT compatible with legacy monitors (DP1, DP6, DP4, AC7, and
                    DP7-PRO)</li>
                  <li>If your firmware is below 3.6.5, we recommend the following upgrade path:
                    3.6.5 {'->'} 4.8.7 {'->'} 5.5.6 {'->'} 6.0.0</li>
                </ul>
              </div>
              <div className="mb-4">
                <h2>
                  <strong>Features Added:</strong>
                </h2>
                <ul className="mb-0">
                  <li>Portrait UI
                    <ul>
                      <li>The monitor now has an option to turn UI elements 90 degrees</li>
                      <li>Settings available in the “Image Rotate” settings section</li>
                    </ul>
                  </li>
                  <li>4K Production Monitor Video Output Improvements
                    <ul>
                      <li>Adds support for cross conversion</li>
                      <li>Adds support for applying LUTs to downstream SDI video</li>
                      <li>Brings SmallHD 4K Monitor behavior in line with the rest of our fleet</li>
                      <li>Signal Routing Diagram shows the Input/Output routing in the Input & Output
                        settings menu (Monitor Settings {'>'} Input & Output)</li>
                    </ul>
                  </li>
                </ul>
              </div>
              <div className="mb-4">
                <h2>
                  <strong>Improvements and Alterations:</strong>
                </h2>
                <ul className="list-txt">
                  <li>Ultra 7 now has a “Max Bright” mode</li>
                  <li>Status Display may now be shown in “Square Division” multiplex mode</li>
                  <li>Added a more prominent warning that running display maintenance on a Quantum
                    monitor may require re-calibrating the display afterwards</li>
                  <li>Q27 monitors may now be set to a 1,000 nit Color Pipe</li>
                  <li>Reworks to HDMI Output functionality
                    <ul>
                      <li>No longer “Enable / Disable” now “ Auto / Force”</li>
                      <li>Auto: HDMI will output so long as a downstream device is detected</li>
                      <li>Force: HDMI will output always, even on an empty cable</li>
                    </ul>
                  </li>
                </ul>

              </div>
              <div className="mb-4">
                <h2 className="d-inline-block">
                  <strong>Bugs Fixed:</strong>
                </h2>
                <ul className="list-txt">
                  <li>Improved stability of SDI 1 Video on 4K production monitors</li>
                  <li>Ultra 7 lock switch is now respected immediately at power-on</li>
                  <li>Improved Ultra 10 Battery Low indicator reliability</li>
                  <li>Fixed an issue with Lift Controls on Ultra 5 monitors</li>
                  <li>Resolved an issue with downstream HDMI audio on UltraBright monitors</li>
                  <li>RED RCP2 Camera Control now allows toggling Record Format</li>
                  <li>Added Native White Point measurement for VISION monitors in the Manual Calibration
                  Wizard</li>
                  <li>Resolved issues when receiving Record Flag from RED KOMODO and Canon C300</li>
                  <li>Function button LUT assignment no longer clears after a restart</li>
                  <li>Prevented an intermittent monitor crash while updating internal Teradek wireless RX/TX
                  4K units</li>
                  <li>Many improvements for supporting uncommon video formats</li>
                </ul>
              </div>
              
              <div className="mb-4">
                <h2 className="d-inline-block">
                  <strong>Recommended Practices</strong>
                </h2>
                <ul className="list-txt">
                  <li><strong><i>Connect external recorders directly downstream of your source device (i.e. camera),
not downstream of the monitor</i></strong></li>
                </ul>
              </div>
            </div>
            <div className="modal-footer">
              <a
                target="_blank"
                onClick={() =>
                  props.showpopupdownload(
                    `${config.downloadFirmwareUrl}beta/SmallHD_PageOS_V6-3-0-beta-0.zip`
                  )
                }
                className="btn btn-primary text-white" data-dismiss="modal" aria-label="Close"
              >
                Download
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BetaFirmware;
